<template>
    <div class="zp-fix-margin">
        <form method="POST" :action="url_formulario" v-on:submit="sendForm" class="zp-errors-border-bottom">
            <input type="hidden" name="_token" :value="csrf">
            <div class="form-group">
                <input type="hidden" name="originTab" value="forget">
                <div class="zp-divisor-recuperar"></div>
                <div class="zp-texto-gris">
                    Escriba el email asociado con la cuenta.
                </div>
                <input type="email" v-model="$v.formForget.email.$model"
                    :class="!$v.formForget.email.$anyError ? 'form-control': 'form-control zp-form-error'"
                    class="form-control" name="email" placeholder="Email" autocomplete="email" autofocus required @keypress="keypress">
            </div>
            <div class="zp-error-data" v-if="$v.formForget.email.$dirty">
                <span v-if="!$v.formForget.email.required" class="zp-error-span">
                    <i class="fas fa-exclamation-circle text-danger"></i>
                    Campo necesario
                </span>
                <span v-if="!$v.formForget.email.email && $v.formForget.email.required" class="zp-error-span">
                    <i class="fas fa-exclamation-circle text-danger"></i>
                    Email inválido
                </span>
            </div>
            <div v-if="showErrorsBackend && message_type != 'ok'" :class="class_container_message_type" >
                <div v-for="error in inputs_errors_cleaned">
                    <div :class="class_message_type">
                        <i class="fas fa-exclamation-circle text-danger" v-if="message_type == 'bad'"></i>
                        {{error[0]}}
                    </div>
                </div>
            </div>
            <div class="zp-divisor-recuperar"></div>
            <button type="submit" class="btn bg-main-color general-btn"
                :disabled="$v.formForget.$invalid">
                {{btnText}}
            </button>
        </form>
    </div>
</template>

<script>
    import { required, minLength, between, sameAs, email } from 'vuelidate/lib/validators'

    export default {
        name: "FormularioPedirCambioContrasena",
        props: [
            "url_formulario",
            "inputs_old",
            "inputs_errors",
            "inputs_errors_emails",
            "token_password",
        ],
        data: function() {
            return  {
                tab_type:"forget",
                inputs_errors_cleaned:[],
                message_type:"bad",
                class_message_type:"zp-error-data",
                class_container_message_type:"zp-error-bag",
                formLoading: false,
                showErrorsBackend:false,
                btnText:"Enviar",
                formForget:{
                    email:"",
                    password:"",
                    recordar:false,
                },
                formReset:{
                    email:"",
                    password:"",
                    password_confirmation:"",
                },
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        validations: {
            formForget:{
                email:{
                    email,
                    required,
                },
            },
            formReset:{
                email:{
                    email,
                    required,
                },
                password:{
                    required
                },
                password_confirmation:{
                    required
                },
            },
        },
        watch:{
        },
        mounted() {

            if(this.inputs_old){
                if(this.inputs_old.originTab == "forget"){

                    let self = this;
                    Object.entries(this.inputs_errors).forEach( function(valor, indice, array){
                        if(valor[0] != "message_type"){
                            self.inputs_errors_cleaned.push(valor[1]);
                        }else{
                            self.message_type = valor[1];
                            if(self.message_type == "ok"){
                                self.class_message_type="zp-ok-data";
                                self.class_container_message_type="alert alert-success";

                                setTimeout(function(){
                                    toastr.options.fadeOut = 10000;
                                    if(self.inputs_errors_cleaned[0]){
                                        toastr.success(self.inputs_errors_cleaned[0]);
                                    }else{
                                        toastr.success("Hemos enviado un correo de cambio de contraseña");
                                    }
                                 }, 500);
                            }
                        }
                    });
                    Object.entries(this.inputs_old).forEach( function(valor, indice, array){
                         if(array[indice][0]){
                            if(array[indice][0] != "_token"){
                                self.formForget[array[indice][0]] = array[indice][1];
                            }
                         }
                    });
                    if(self.message_type != "ok"){
                        $('#passwordModal').modal('show');
                        $('.zp-auth-forget').show();
                        $('.zp-auth-change_password').hide();
                        this.showErrorsBackend = true;
                    }
                }
            }

            let self = this;
            document.addEventListener('evento-cerrar-modales', function (e) {
                self.$v.$reset();
                self.showErrorsBackend = false;
            }, false);
        },
        methods:{
            showForgetSection(){
                $("#pills-forget-tab").click();
            },
            keypress(){
                this.showErrorsBackend = false;
            },
            sendFormReset (event) {
                if(!this.formLoading){
                    this.formLoading = true;
                    this.btnText = "Enviando...";
                    return true;
                }
                event.preventDefault();
                return false;
            },
            sendForm (event) {
                if(!this.formLoading){
                    this.formLoading = true;
                    this.btnText = "Enviando...";
                    return true;
                }
                event.preventDefault();
                return false;
            },
            onlyNumber ($event) {
               let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
               if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                  $event.preventDefault();
               }
            },
            onlyLetters ($event) {
               var regex = new RegExp("^[a-zA-Z ]+$");
                var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                }
            }
        }
    }
</script>

<style>

</style>
